<template>
    <section class="TimetableBlock" :id=block_id>
        <div class="bg-neutral-50">
            <div class="container-block">
                <div class="grid grid-cols-1 gap-8 lg:grid-cols-12 md:gap-12 lg:gap-8">
                    
                    <div class="flex flex-col items-start w-full col-span-1 lg:col-span-5">

                        <!-- Headline -->
                        <h2 class="mb-3 head-md text-neutral-800">{{ headline }}</h2>

                        <!-- Copy -->
                        <div class="max-w-[35ch] text-neutral-600 body-md">
                            <p>{{ copy }}</p>
                        </div>
    
                    </div>

                    <!-- Times -->
                    <div class="grid w-full grid-cols-2 col-span-1 gap-x-4 gap-y-6 sm:grid-cols-3 lg:col-span-7 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 md:gap-y-8 md:gap-x-6 lg:gap-8">
                        
                        <!-- Individual Times -->
                        <div v-for="time in times" :key="time.id" class="flex flex-col gap-2">

                            <!-- Day -->
                            <h3 class="head-xs text-neutral-700">{{ time.day }}</h3>

                            <!-- Times -->
                            <div class="flex items-center space-x-1">
                                <svg class="flex-shrink-0 w-6 h-6 text-neutral-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <p class="body-md text-neutral-600 whitespace-nowrap">{{ time.hours }}</p>
                            </div>

                        </div>

                    </div>
                    
                    <!-- API Times -- >
                    <div v-if="openingHours">
                        <p>Monday: {{ openingHours.monday }}</p>
                        <p>Tuesday: {{ openingHours.tuesday }}</p>
                        <p>Wednesday: {{ openingHours.wednesday }}</p>
                        <p>Thursday: {{ openingHours.thursday }}</p>
                        <p>Friday: {{ openingHours.friday }}</p>
                        <p>Saturday: {{ openingHours.saturday }}</p>
                        <p>Sunday: {{ openingHours.sunday }}</p>
                    </div> -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import axios from 'axios';

export default {
    
    name: 'TimetableBlock',

    props: {
        content: Object, // Hero Content
    },
    
    data() {
        return {

            // Content
            block_id: this.content.block_id,
            headline: this.content.headline,
            copy: this.content.copy,
            times: this.content.times,

            // Places API
            placeId: 'ChIJwVdOwZQPhEgRJA-Eo5T3aMQ',             // Business ID
            apiKey: 'AIzaSyDnQ92kbOHr4Uezi4EP1JeryFVWnGqSVvQ',  // API Key
            openingHours: null,

        };
    },

    mounted() {
        //this.getOpeningHours();
    },
    
    methods: {
        getOpeningHours() {

            // Google Places API
            const url = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${this.placeId}&fields=name,opening_hours&key=${this.apiKey}`;

            axios
            .get(url)                                               // Make API Call
            .then((response) => {
                const hours = response.data.result.opening_hours;   // Retrieve 
                this.openingHours = hours;
            })
            .catch((error) => {
                console.error(error);
            });
        },
    },
};
</script>
